<span
        class="w-full flex flex-col px-3 py-2 {{inputContainerClass}} {{animation}} dark:text-white"
        [style.--order]="order"
>
  <!-- Label -->
  <data-label
          *ngIf="label || subLabel || icon"
          [order]="order + 1"
          [active]="active"
          [inContainer]="false"
          [toolTip]="labelToolTip ?? toolTip"
          [label]="label"
          [icon]="icon"
          [iconClass]="iconClass"
          (click)="labelClick.emit(true)"
  ></data-label>

    <!-- Date/Close Button -->
  <span
          *ngIf="date || endDate"
          [style.--order]="order + 1"
          class="px-2 py-1 ms-1 rounded-md border dark:border-gray-700 text-dark dark:text-gray-300 bg-slightly-faded-gradient dark:bg-gray-800 cursor-pointer animate"
          (click)="cancel.emit(true)"
  >
    <mat-icon class="icon-small text-danger dark:text-red-500">close</mat-icon>
  </span>

    <!-- Data Input -->
  <data-input
          *ngIf="keys.length"
          type="select"
          [maxWidth]="maxWidth"
          [suffixIcon]="keySuffixIcon"
          [toolTip]="keyToolTip"
          [order]="order + 1.5"
          [options]="keys"
          [value]="selectedKey"
          (change)="selectedKeyChange.emit($event)"
          [inContainer]="false"
          [multiple]="false"
          class="dark:bg-gray-800 dark:text-gray-300"
  ></data-input>

    <!-- Divider -->
  <span *ngIf="dateRange && keys.length" class="very-faded top--2 px-1 dark:text-gray-500"> | </span>

    <!-- Start Date Input -->
  <mat-form-field
          appearance="fill"
          [matTooltip]="toolTip"
          class="custom-fill hide-arrow bg-none material-form dark:bg-gray-800 dark:text-gray-300"
          [style.max-width]="maxWidth"
  >
    <span matPrefix class="faded dark:text-gray-400" *ngIf="!date">
      {{ dateRange ? startDateLabel : selectedKey | camelToTitleCase }}
    </span>
    <input
            [matDatepicker]="date_"
            [(ngModel)]="date"
            matInput
            (dateChange)="onDateChange($event)"
            class="dark:bg-gray-800 dark:text-gray-300"
    />
    <mat-datepicker-toggle [for]="date_" matSuffix></mat-datepicker-toggle>
    <mat-datepicker #date_></mat-datepicker>
  </mat-form-field>

    <!-- End Date Input (if dateRange is true) -->
  <ng-container *ngIf="dateRange">
    <span class="very-faded top--2 px-1 dark:text-gray-500"> | </span>
    <mat-form-field
            appearance="fill"
            [matTooltip]="endDateToolTip"
            class="custom-fill hide-arrow bg-none material-form dark:bg-gray-800 dark:text-gray-300"
            [style.max-width]="maxWidth"
    >
      <span matPrefix class="faded dark:text-gray-400" *ngIf="!endDate"> {{ endDateLabel }} </span>
      <input
              [matDatepicker]="date_"
              [(ngModel)]="endDate"
              (dateChange)="onEndDateChange($event)"
              matInput
              class="dark:bg-gray-800 dark:text-gray-300"
      />
      <mat-datepicker-toggle [for]="date_" matSuffix></mat-datepicker-toggle>
      <mat-datepicker #date_></mat-datepicker>
    </mat-form-field>
  </ng-container>
</span>